import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from 'libs/portal/src/models/User';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent {
  user: User;
  isResetPassword: boolean;

  constructor(private params: ActivatedRoute) {
    this.params.queryParams.subscribe((params) => {
      this.user = params.user;
      this.isResetPassword = params.isResetPassword;
    });
  }
}
